import TimKoordinasiContent from "../../components/layouts/tentang/TimKoordinasiContent";

import React from "react";

const TimKoordinasi: React.FC = () => {
  return (
    <div>
      <TimKoordinasiContent />
    </div>
  );
};

export default TimKoordinasi;
